import type { AnalyticsEventPayload } from '@atlaskit/analytics-next';

import { filterCommonAttributes } from '../ai-answer-dialog/analytics-helpers';
import type { commonAttributesType } from '../ai-answer-dialog/types';

// eslint-disable-next-line no-barrel-files/no-barrel-files
export { onKnowledgeCardShown } from './on-knowledge-card-shown';
// eslint-disable-next-line no-barrel-files/no-barrel-files
export { onNonGenerativeKnowledgeCardLinkClick } from './on-non-generative-knowledge-card-link-click';
// eslint-disable-next-line no-barrel-files/no-barrel-files
export { onAgentKnowledgeCardCarouselShown } from './on-agent-knowledge-card-carousel-shown';
// eslint-disable-next-line no-barrel-files/no-barrel-files
export { onAgentKnowledgeCardCarouselItemClick } from './on-agent-knowledge-card-carousel-item-click';
// eslint-disable-next-line no-barrel-files/no-barrel-files
export { onIndividualAgentKnowledgeCardShown } from './on-individual-agent-knowledge-card-shown';
// eslint-disable-next-line no-barrel-files/no-barrel-files
export { onPersonCardOrgChartShown } from './on-person-card-org-chart-shown';
// eslint-disable-next-line no-barrel-files/no-barrel-files
export { onPersonCardOrgChartDwelled } from './on-person-card-org-chart-dwelled';
// eslint-disable-next-line no-barrel-files/no-barrel-files
export { onPersonCardOrgChartCardClicked } from './on-person-card-org-chart-card-clicked';

interface KnowledgeCardLinkClickProps extends commonAttributesType {
	location: string;
	position?: number;
	shownAfterCardBodyExpanded?: boolean;
	isAuxClick?: boolean;
	isContextMenu?: boolean;
}

export const onKnowledgeCardLinkClick = (
	props: KnowledgeCardLinkClickProps,
): AnalyticsEventPayload => {
	const { source, location, position, shownAfterCardBodyExpanded, isAuxClick, isContextMenu } =
		props;
	return {
		action: 'clicked',
		actionSubject: 'aiAnswerDialog',
		actionSubjectId: 'knowledgeCardLink',
		source: source,
		eventType: 'track',
		attributes: {
			...filterCommonAttributes(props),
			location,
			position,
			shownAfterCardBodyExpanded,
			isAuxClick,
			isContextMenu,
		},
	};
};
